<template>
  <v-container id="taxslab-edit" fluid tag="section">
    <v-row justify="center">
      <v-col cols="12" md="10">
        <v-form v-model="isValid" ref="form">
          <v-card>
            <v-toolbar color="white" fixed>
              <h3>{{ $i18n.t(label) }}</h3>
            </v-toolbar>
            <v-card-text>
              <v-container dense>
                <v-row>
                  <v-col cols="12" sm="6" md="3">
                    <v-text-field
                      v-model="corporate.name"
                      :label="$i18n.t('Short Name') + '*'"
                      :rules="validationrules.name"
                      required
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="6" md="3">
                    <v-text-field
                      v-model="corporate.fullName"
                      :label="$i18n.t('Full Name') + '*'"
                      :rules="validationrules.fullName"
                      required
                    ></v-text-field>
                  </v-col>

                  <v-col cols="12" sm="6" md="3">
                    <z-entity-select
                      :corp="forOwner_id"
                      v-model="corporate.vendorEntity_id"
                      :label="$i18n.t('Company Entity')"
                    />
                  </v-col>
                  <v-col cols="12" sm="6" md="3">
                   <v-text-field
                      v-model="corporate.vendorTransportCode"
                      :label="$i18n.t('Transport Code')"
                      
                      required
                    ></v-text-field>
                  </v-col>
                </v-row>
                <v-row>
                  <h4>Address</h4>
                </v-row>

                <v-row>
                  <v-col cols="12" sm="6" md="6">
                    <z-country-select
                      required
                      v-model="corporate.address.country"
                      :rules="validationrules.addressCountry"
                    ></z-country-select>
                  </v-col>
                  <v-col cols="12" sm="6" md="6">
                    <z-state-select
                      required
                      v-model="corporate.address.state"
                      :country="corporate.address.country"
                      :rules="validationrules.addressState"
                    ></z-state-select>
                  </v-col>
                  <v-col cols="12" sm="6" md="6">
                    <z-city-select
                      required
                      v-model="corporate.address.city"
                      :country="corporate.address.country"
                      :rules="validationrules.addressCity"
                    ></z-city-select>
                  </v-col>
                  <v-col cols="12" sm="6" md="6">
                    <v-text-field
                      :label="$i18n.t('Address')"
                      required
                      v-model="corporate.address.addressLine"
                      :rules="validationrules.addressAddressLine"
                    ></v-text-field>
                  </v-col>
                </v-row>
                <v-row>
                  <h4>Organization Information</h4>
                </v-row>
                <v-row>
                  <v-col cols="12" sm="6" md="6">
                    <v-text-field
                      :label="$i18n.t('PAN')"
                      required
                      v-model="corporate.PANNo"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="6" md="6">
                    <v-text-field
                      :label="$i18n.t('GSTIN')"
                      required
                      v-model="corporate.GSTNo"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="6" md="6">
                    <v-text-field
                      :label="$i18n.t('TAN')"
                      required
                      v-model="corporate.TANNo"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="6" md="6">
                    <v-text-field
                      :label="$i18n.t('CIN')"
                      required
                      v-model="corporate.CINno"
                    ></v-text-field>
                  </v-col>
                </v-row>
                <!-- <v-row>
                  <h4>Admin Details</h4>
                </v-row>

                <v-row>
                  <v-col cols="12" md="12">
                    <v-text-field
                      :label="$i18n.t('Admin Name') + '*'"
                      required
                      v-model="corporate.adminName"
                      :rules="validationrules.adminName"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" md="3">
                    <z-country-select
                      :label="$i18n.t('Country Code') + '*'"
                      required
                      isd
                      hideName
                      v-model="corporate.countryCodeAdmin"
                      :rules="validationrules.countryCodeAdmin"
                    ></z-country-select>
                  </v-col>
                  <v-col cols="12" md="3">
                    <v-text-field
                      :label="$i18n.t('Phone') + '*'"
                      required
                      type="number"
                      v-model="corporate.phoneAdmin"
                      :rules="validationrules.phoneAdmin"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" md="6">
                    <v-text-field
                      :label="$i18n.t('Email') + '*'"
                      required
                      v-model="corporate.email"
                      :rules="validationrules.email"
                    ></v-text-field>
                  </v-col>
                </v-row> -->
              </v-container>
            </v-card-text>
            <v-card-actions>
              <small>*indicates required field</small>
              <v-spacer></v-spacer>
              <v-checkbox
                v-model="corporate.doNotNotify"
                :label="'Do Not Notify'"
              ></v-checkbox>
              <v-btn
                class="ml-2"
                color="success darken-1"
                @click="save()"
                :loading="loading"
                :disabled="!isValid"
                >Save</v-btn
              >
            </v-card-actions>
          </v-card>
        </v-form>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { doPost } from "@/store/common/module/apis";
import common from "@/store/common/module/common";
import CorpService from "@/store/common/module/CorpService";
import { Vue, Component, Watch } from "vue-property-decorator";
import auth from "@/store/user/module/auth";

@Component({
  name: "ClientCreate",
  props: {
    label: {
      default: "Create Client",
    },
    singlePage: {
      default: false,
    },
    owner_id: {
      default: null,
    },
  },
})
export default class ClientCreate extends Vue {
  isValid = true;
  forOwner_id = null;
  corpPOSO = {
    _id: null,
    name: "",
    fullName: "",
    TANNo: "",
    GSTNo: "",
    PANNo: "",
    CINno: "",
    phoneAdmin: "",
    adminName: "",
    countryCodeAdmin: "",
    email: "",
    doNotNotify: false,
    vendorTransportCode: null,
    client: { name: null },
    address: { country: "India", state: "", city: "", addressLine: "" },
  };
  corporate = this.corpPOSO;
  path = "";
  leftColStyles = {};

  get loading() {
    return common.loading;
  }

  validationrules = {
    
    name: [(v) => !!v || this.$i18n.t("Name is required")],
    fullName: [(v) => !!v || this.$i18n.t("Full Name is required")],
    addressCountry: [(v) => !!v || this.$i18n.t("Country is required")],
    addressCity: [(v) => !!v || this.$i18n.t("City is required")],
    addressState: [(v) => !!v || this.$i18n.t("State is required")],
    addressAddressLine: [(v) => !!v || this.$i18n.t("Address is required")],
    adminName: [(v) => !!v || this.$i18n.t("Admin Name is required")],
    countryCodeAdmin: [
      (v) => !!v || this.$i18n.t("Admin Phone Code is required"),
    ],
    phoneAdmin: [
      (v) => !!v || this.$i18n.t("Admin Phone no is required"),
      (v) =>
        !isNaN(parseInt(v)) || this.$i18n.t("Admin Phone no should be valid"),
    ],
    email: [
      (v) => !!v || "E-mail is required",
      (v) => /.+@.+\..+/.test(v) || "E-mail must be valid",
    ],
  };

  closeDialog() {
    this.$emit("closeDialog", false);
  }

  @Watch("owner_id")
  async onOwnerChange(val) {
    if (!val) {
      await auth.doPostLogin();
      const webcontent = auth.authContent;
      if (webcontent && webcontent.owner_id)
        this.forOwner_id = webcontent.owner_id;
    } else {
      this.forOwner_id = this.owner_id;
    }
  }

  async mounted() {
    if (!this.owner_id) {
      await auth.doPostLogin();
      const webcontent = auth.authContent;
      if (webcontent && webcontent.owner_id)
        this.forOwner_id = webcontent.owner_id;
    } else {
      this.forOwner_id = this.owner_id;
    }
  }

  async save() {
    try {
      common.setLoading(true);
      this.corporate = await doPost("/api/create/client/dms", this.corporate);
      common.setLoading(false);
      common.showMessage("Saved Successfully");
      CorpService.clearClients();

      if (this.singlePage) {
        // this.$emit("select", {
        //   name: this.corporate.client.name,
        //   _id: this.corporate._id,
        // });
        this.$emit("select", this.corporate);
        this.corporate = this.corpPOSO;
      } else {
        this.$router.push("/settings/clients");
      }
    } catch (e) {
      common.setError(e.message);
      common.setLoading(false);
    }
  }
}
</script>
